import { AfterViewInit, Component, ElementRef, HostListener, Input, Renderer2, ViewChild } from "@angular/core";
import WOW from 'wowjs';

@Component({
    selector: 'app-website-header',
    templateUrl: './website-header.component.html',
    styleUrls: ['./website-header.component.scss']
})

export class WebsiteHeaderComponent {
    @ViewChild('navbar') navbar!: ElementRef;
    @Input() customerContent: boolean = false;
    isTopBarShow: boolean = true;
    private ticking = false;
    isNavbarCollapsed = true;


    @HostListener('window:scroll', [])
    onWindowScroll(): void {
        if (!this.ticking) {
            window.requestAnimationFrame(() => {
                this.isTopBarShow = window.scrollY <= 10;
                this.ticking = false;
            });
            this.ticking = true;
        }
    }

    toggleNavbar() {
        this.isNavbarCollapsed = !this.isNavbarCollapsed;
    }

    openManualFor() {
        const userType = localStorage.getItem('userType');
        const baseUrl = window.location.origin;

        if (userType === 'CUSTOMER') {
            window.open(`${baseUrl}/#/app-workflow`, '_blank');
        } else if (userType === 'SHOP_OWNER') {
            window.open(`${baseUrl}/#/vendor-app`, '_blank');
        }
    }
}